import { defineMessages } from 'react-intl';

export default defineMessages({
	removeCta: {
		id: 'profile.manageSubscription.removeMember.removeCta',
		defaultMessage: 'Yes, Remove',
		description: 'The button that triggers the member removal',
	},
});
